import React from "react";
import { Form } from "react-bootstrap";

export function CourseHourForm({
  index,
  handleChange,
  values
 }) {
  const weekdayStartHour = "courseHours[" + index + "].weekdayStartHour";
  const weekdayEndHour = "courseHours[" + index + "].weekdayEndHour";
  const weekendStartHour = "courseHours[" + index + "].weekendStartHour";
  const weekendEndHour = "courseHours[" + index + "].weekendEndHour";

  return (
    <div className="form-group row">
      <div className="col-2">
        <Form.Label column>
          {index + 1}
        </Form.Label>
      </div>
      <div className="col-5">
        <div className="row">
          <div className="col-6">
            <Form.Control
              type="time" 
              value={values[index].weekdayStartHour} 
              onChange={e => handleChange(weekdayStartHour)(e.target.value)} 
            />
          </div>
          <div className="col-6">
            <Form.Control 
              type="time"
              value={values[index].weekdayEndHour}
              onChange={e => handleChange(weekdayEndHour)(e.target.value)} />
          </div>
        </div>
      </div>
      <div className="col-5">
        <div className="row">
          <div className="col-6">              
            <Form.Control 
              type="time"
              value={values[index].weekendStartHour}
              onChange={e => handleChange(weekendStartHour)(e.target.value)} />
          </div>
          <div className="col-6">
            <Form.Control 
              type="time"
              value={values[index].weekendEndHour}
              onChange={e => handleChange(weekendEndHour)(e.target.value)} />
          </div>
        </div>
      </div>        
    </div>
  );
}